// Estilos y layouts compartidos por las tablas del PDF de gafas.

export const pdfStyles = {
  th: { bold: true, alignment: "center", fillColor: "#FFFFFF", fontSize: 8 },
  ty: { bold: true, alignment: "center", fillColor: "#FFFFFF", margin: [0, 5, 0, 0], fontSize: 8 },
};

// Layout púrpura: rejilla completa con padding mínimo.
export function getPurpleGrid() {
  return {
    hLineColor: () => "#222222 ",
    vLineColor: () => "#222222 ",
    paddingLeft: () => 3,
    paddingRight: () => 3,
    paddingTop: () => 2,
    paddingBottom: () => 2,
  };
}
